// plop_marker:layouts_import
import CarouselTestimonials from "./carousel-testimonials/index.js";
import PlainClassicTestimonials from "./plain-classic-testimonials/index.js";
export default {
    // plop_marker:layouts_add_layout
    CarouselTestimonials,
    PlainClassicTestimonials
};
